import React from "react";
import { Box, Typography, Avatar, Grid, ListItem, List, Tooltip, capitalize } from "@mui/material";
import RectangleIcon from "@mui/icons-material/Rectangle";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import queryGraphql from "../../helpers/ApiInterface";
interface ApplicationsTableProps {
	columnFilters: any;
	applications: any;
	type: any;
	resourceStatuses: any;
}

const ApplicationsTable: React.FC<ApplicationsTableProps> = ({
	columnFilters,
	applications,
	type,
	resourceStatuses
}: any) => {
	const [deleteButton, setDeleteButton] = React.useState<boolean>(false);
	const [cardHoverIndex, setCardHoverIndex] = React.useState<number | null>(null);
	const navigate = useNavigate();

	return (
		<List sx={{ bgcolor: "#fafafa" }}>
			<ListItem sx={{ bgcolor: "#f2f2f2", borderRadius: "4px" }}>
				<Box width="100%">
					<Grid container direction="row" alignItems="center">
						<Grid item xs={2}>
							<Typography fontSize="12px">APPLICATION NAME</Typography>
						</Grid>
						<Grid item xs={2}>
							<Typography fontSize="12px">CLUSTER NAME</Typography>
						</Grid>
						<Grid textAlign="start" item xs={2}>
							<Typography fontSize="12px">ENVIRONMENT</Typography>
						</Grid>
						<Grid item textAlign="start" xs={2}>
							<Typography fontSize="12px">OWNER</Typography>
						</Grid>
						<Grid item textAlign="start" xs={2}>
							<Typography fontSize="12px">
								{type == "rejected" ? "REJECTED BY/ REASON" : "NO. OF SERVICES"}
							</Typography>
						</Grid>
						<Grid item textAlign="start" xs={2}>
							<Typography fontSize="12px">REQUESTED ON</Typography>
						</Grid>
					</Grid>
				</Box>
			</ListItem>
			{applications.map((application: any, index: number) => (
				<ListItem
					sx={{
						border: cardHoverIndex == index ? "1px solid #000" : "1px solid #00000000",
						mt: 1,

						bgcolor: type == "active" ? "#FFFFFF" : type == "rejected" ? "#F0443810" : "#FDB02210",
						borderRadius: "8px",
						cursor: "pointer",
					}}
					onMouseEnter={() => setCardHoverIndex(index)}
					onMouseLeave={() => {
						setCardHoverIndex(null);
					}}
					onClick={() => {
						navigate(`/applications/details/${application.id}`);
					}}
				>
					<Box width="100%">
						<Grid container direction="row" alignItems="center" justifyContent="space-between">
							<Grid item xs={2}>
								{columnFilters.applicationName && (
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<RectangleIcon
											sx={{
												color:
													type == "active" ? "#12B76A" : type == "rejected" ? "#F04438" : "#FDB022",
												bgcolor:
													type == "active" ? "#12B76A" : type == "rejected" ? "#F04438" : "#FDB022",
												width: "4px",
												marginRight: "8px",
											}}
										/>
										<Typography fontSize="14px" fontFamily="Gilroy-Medium">
											{application.applicationName}
										</Typography>{application && application.status === 'active' ? ( 
										  <Tooltip
											sx={{ whiteSpace: "pre-line" }}
											title={
											  <Box key="applications-tooltip"> 
												Current Status
												<br />
												{resourceStatuses.filter((e:any) => e.resourceId == application.id).map((e: any, index: number) => (
												  <React.Fragment key={index}>
													{capitalize(e.currentStatus)}
													<br />
												  </React.Fragment>
												))}
												
											  </Box>
											}
										  >
											<Avatar
											  src="/assets/info.svg"
											  alt="info"
											  sx={{ height: 16, width: 16, marginLeft: "4px" }}
											/>
										  </Tooltip>
										) : null}
									</Box>
								)}
							</Grid>
							<Grid item xs={2}>
								{columnFilters.clusterName && (
									<Typography fontSize="14px" fontFamily="Gilroy-Regular">
										{application.clusterName ? application.clusterName : "-"}
									</Typography>
								)}
							</Grid>
							<Grid item xs={2}>
								{columnFilters.environment && (
									<Typography fontSize="14px" fontFamily="Gilroy-Regular">
										{application.environment}
									</Typography>
								)}
							</Grid>

							<Grid item xs={2}>
								{columnFilters.applicationOwner && (
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<Avatar
											src={application.applicationOwnerAvatar}
											alt={application.applicationOwner}
											sx={{ marginRight: "8px", height: 30, width: 30 }}
										/>
										<Typography fontSize="14px" fontFamily="Gilroy-Regular">
											{application.applicationOwner}
										</Typography>
									</Box>
								)}
							</Grid>
							<Grid item xs={2}>
								{columnFilters.services && application?.status == "active" && (
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<Typography fontSize="14px" fontFamily="Gilroy-Regular">
											{application.services?.length || 0}
										</Typography>
										{application.services?.length > 0 && (
											<Tooltip
												sx={{ whiteSpace: "pre-line" }}
												title={
													<>
														Services
														<br />
														{application.services?.length > 0 &&
															application.services?.map((e: any, index: number) => (
																<>
																	{`${index + 1}. ${e.serviceName}`}
																	<br />
																</>
															))}
													</>
												}
											>
												<Avatar
													src="/assets/info.svg"
													alt="info"
													sx={{ height: 16, width: 16, marginLeft: "4px" }}
												/>
											</Tooltip>
										)}
									</Box>
								)}
								{columnFilters.applications && type == "rejected" && (
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<Avatar
											src={application.applicationApprover?.googleProfilePicture}
											alt={application.applicationApprover?.name}
											sx={{ marginRight: "8px", height: 30, width: 30 }}
										/>
										<Typography fontSize="14px" fontFamily="Gilroy-Regular">
											{application.applicationApprover?.name}
										</Typography>
										<Tooltip
											sx={{ whiteSpace: "pre-line" }}
											// title={application.applications?.map(
											// 	(e: any, index: number) => `${e.applicationName}`
											// )}
											title={
												<>
													Reason of Rejection
													<br />
													{application.reasonForRejection || ""}
												</>
											}
										>
											<Avatar
												src="/assets/info.svg"
												alt="info"
												sx={{ height: 16, width: 16, marginLeft: "4px" }}
											/>
										</Tooltip>
									</Box>
								)}
							</Grid>
							<Grid item xs={2}>
								{columnFilters.createdAt && (
									<Box display="flex" alignItems="center" justifyContent="space-between">
										<Typography fontSize="14px" fontFamily="Gilroy-Regular">
											{moment(application.createdAt).format("DD/MM/YYYY | hh:mm A")}
										</Typography>
									</Box>
								)}
							</Grid>
						</Grid>
					</Box>
				</ListItem>
			))}
		</List>
	);
};

export default ApplicationsTable;
